import styles from './ManageProf.module.css';
import Button from '../../Button/Button';
import {getAllProfessionsUrl, getAllRulesUrl, getAllFileTemplatesUrl, getAllTemplateBindsUrl} from '../../../helpers/constants';
import React, {useEffect, useMemo, useReducer, useState} from 'react';
import {SelectForm} from '../../SelectForm/SelectForm';
import {Tooltip} from 'react-tooltip';
import InputForm from '../../InputForm/InputForm';
import {formReducer, INITIAL_STATE} from './manageProf.state';
import useApi from '../../../hooks/useApi.hook';
import ErrorMessage from '../../ErrorMessage/ErrorMessage';
import BindItems from '../../BindItems/BindItems';
import BindTemplates from '../../BindItems/BindTemplates/BindTemplates';
import useFillSelect from '../../../hooks/useFillSelect.hook';
import useTemplateRegistry from '../../../hooks/useTemplateRegistry.hook';
import VerticalTabs from '../../VerticalTabs/VerticalTabs';


export function ManageProf({optionsProf, getProfessions, optionsIns}) {
	const [errorApi, setErrorApi] = useState(undefined);
	const [state, dispatchForm] = useReducer(formReducer, INITIAL_STATE);
	const api = useApi();
	const [loading, setLoading] = useState(false);
	const [uploadedOk, setUploadedOk] = useState(false);
	const [rightPanelOpen, setRightPanelOpen] = useState(false);
	const {
		valueProf,
		subModalOpen,
		visibleDelButton,
		values,
		isValid,
		errors,
		isFormReadyToSubmit
	} = state;


	const optionsProfWide = [
		{ value: 0, label: '---Создать новую профессию---'},
		...optionsProf
	];

	const {
		itemDict: rulesDict,
		getItems: getRules
	} = useFillSelect({
		endpoint: getAllRulesUrl,
		labelField: 'id'
	});

	const {
		itemDict: fileTemplatesDict
	} = useFillSelect({
		endpoint: getAllFileTemplatesUrl,
		labelField: 'file_name'
	});

	const {groupTemplates} = useTemplateRegistry();
	const personalTemplates = groupTemplates('personal');

	const optionsFileTemplates = useMemo(() => {
		const byFileName = Object.fromEntries(
			Object.values(fileTemplatesDict).map(ft => [ft.file_name, ft])
		);
		return personalTemplates
			.filter(t => byFileName[t.code])
			.map(t => ({ value: String(byFileName[t.code].id), label: t.title }));
	}, [fileTemplatesDict, personalTemplates]);

	const {
		itemDict: bindsDict,
		getItems: getBinds
	} = useFillSelect({
		endpoint: getAllTemplateBindsUrl,
		labelField: 'id'
	});

	const renderButtonText = () => {
		if (loading) return 'Загрузка…';
		if (uploadedOk) return valueProf ? '✓ Сохранен' : '✓ Удален';
		return valueProf ? 'Редактировать' : 'Создать';
	};

	const showSuccess = (ms = 1500) => {
		setUploadedOk(true);
		setTimeout(() => setUploadedOk(false), ms);
	};

	const manageProfApi = async (payload, isDelete = false) => {
		let response;
		setLoading(true);
		try {
			if (valueProf) {
				if (isDelete) {
					await api.delete(`${getAllProfessionsUrl}${valueProf}`);
				} else {
					response = await api.patch(`${getAllProfessionsUrl}${valueProf}`, payload);
				}
			} else {
				response = await api.post(`${getAllProfessionsUrl}`, payload);
			}
			getProfessions();
			if (response) {
				const { id, title, description } = response.data;
				dispatchForm({type: 'SET_SUB_MODAL', payload: false});
				dispatchForm({type: 'SET_VISIBLE_DEL_BUTTON', payload: true});
				dispatchForm({type: 'SET_VALUE_PROF', payload: Number(id)});
				dispatchForm({type: 'RESET_VALIDITY'});
				dispatchForm({
					type: 'SET_VALUE', payload:
					{
						'title': title,
						'description': description
					}}
				);
			}
			showSuccess(1500);
		} catch (e) {
			setErrorApi(
				e.response?.data?.detail || e.response?.data?.message || 'Неизвестная ошибка'
			);
		} finally {
			setLoading(false);
		}
	};

	const selectProf = (option) => {
		dispatchForm({type: 'SET_SUB_MODAL', payload: false});
		dispatchForm({type: 'SET_VISIBLE_DEL_BUTTON', payload: true});
		dispatchForm({type: 'SET_VALUE_PROF', payload: Number(option.value)});
		dispatchForm({type: 'RESET_VALIDITY'});
		if (option.value !== 0) {
			dispatchForm({
				type: 'SET_VALUE', payload:
					{
						'title': option.label,
						'description': option.description
					}}
			);
		} else {
			dispatchForm({type: 'CLEAR'});
		}
	};

	const onChange = (e) => {
		dispatchForm({type: 'SET_SUB_MODAL', payload: false});
		dispatchForm({type: 'SET_VISIBLE_DEL_BUTTON', payload: false});
		dispatchForm({type: 'SET_VALUE', payload: { [e.target.name]: e.target.value}});
		dispatchForm({type: 'RESET_VALIDITY'});
	};

	const creatEditProf = () => {
		dispatchForm({type: 'SUBMIT'});
	};

	const deleteProf = () => {
		manageProfApi({}, true);
		dispatchForm({ type: 'CLEAR' });
		dispatchForm({type: 'SET_VALUE_PROF', payload: 0});
		dispatchForm({type: 'SET_SUB_MODAL', payload: false});
	};

	useEffect(() => {
		if (isFormReadyToSubmit) {
			manageProfApi(values);
			dispatchForm({ type: 'SET_SUBMIT_FALSE' });
		}
	}, [isFormReadyToSubmit]);

	const selectedOption = optionsProfWide.find(o => Number(o.value) === Number(valueProf)) || optionsProfWide[0];

	return (
		<div className={styles['manage_prof']}>
			<h1 className={styles['title']}>Управление профессиями</h1>
			<ErrorMessage
				error={errorApi}
				onClose={() => setErrorApi(undefined)}
			/>

			<div className={styles['content']}>
				<div className={styles['left_panel']}>
					<span className={styles['span']}>
					Профессии:
						<SelectForm
							value={selectedOption}
							options={optionsProfWide}
							name="profession_id"
							onChange={selectProf}
						/>
					</span>
					<div className={styles['box']}>
						<span className={styles['box-title']}>Параметры профессии</span>
						<div className={styles['box-content']}>
							<span
								className={styles['span']}
								data-tooltip-content={errors.title}
								data-tooltip-id="errorTooltipTitle"
							>
						Наименование*:
								<InputForm
									maxLength={64}
									value={values.title}
									isValid={isValid.title}
									type="text"
									name="title"
									placeholder="Наименование"
									onChange={onChange}
								/>
								<Tooltip
									id="errorTooltipTitle"
									place="top-end"
									content={errors.title}
									isOpen={!isValid.title}
									className={styles['my-tooltip']}
								/>
							</span>
							<span className={styles['span']}>
						Описание:
								<InputForm
									value={values.description ?? ''}
									type="text"
									name="description"
									placeholder="Описание"
									onChange={onChange}
								/>
							</span>
							<div className={styles['button-box']}>
								{(Boolean(valueProf) && visibleDelButton) && <div className={styles['inline']}>
									<button className={styles.iconButton}
										onClick={() => {
											dispatchForm({type: 'SET_SUB_MODAL', payload: true});
											dispatchForm({type: 'SET_VISIBLE_DEL_BUTTON', payload: false});

										}}
									>
										<img
											className={styles.iconImage}
											src="/icons/delete-icon.svg"
											alt="delete"/>
									</button>
								</div>}
								{subModalOpen && <div className={styles['submodal']}>
									<Button className={styles.button_submodal} onClick={deleteProf}>
										Удалить
									</Button>
									<Button className={styles.button_submodal} onClick={() => {
										dispatchForm({type: 'SET_SUB_MODAL', payload: false});
										dispatchForm({type: 'SET_VISIBLE_DEL_BUTTON', payload: true});
									}}>
										Отмена
									</Button>
								</div>
								}
							</div>
						</div>
					</div>
					<div className={styles['button']}>
						<Button
							onClick={creatEditProf}
							disabled={loading}
							className={`${styles.uploadBtn} ${uploadedOk ? styles.uploadedOkBtn : ''}`}
						>
							{renderButtonText()}
						</Button>
					</div>
				</div>
				<VerticalTabs
					tabs={[
						{ id: 'instructions', label: 'Инструкции' },
						{ id: 'templates', label: 'Шаблоны' }
					]}
					activeTab={rightPanelOpen}
					onChange={setRightPanelOpen}
					visible={Boolean(valueProf)}
				/>
				<div className={`${styles['right_panel']} ${rightPanelOpen ? styles['right_panel_open'] : ''}`}>
					<div className={styles['tab_content']}>
						{rightPanelOpen === 'instructions' && (
							<BindItems
								valueBind={valueProf}
								options={optionsIns}
								setErrorApi={setErrorApi}
								getRules={getRules}
								rulesDict={rulesDict}
								bindType={'prof'}
							/>
						)}
						{rightPanelOpen === 'templates' && (
							<BindTemplates
								valueProfId={valueProf}
								options={optionsFileTemplates}
								setErrorApi={setErrorApi}
								getBinds={getBinds}
								bindsDict={bindsDict}
							/>
						)}
					</div>
				</div>
			</div>
		</div>
	);
}
